import { Checkbox } from "@certn/cascadia-react";
import type { ReactNode } from "react";

import { useQueryParams } from "../../../hooks/useQueryParams";

export type QueryParamBooleanFilterProps = {
  paramName: string;
  testID: string;
  /** Caller supplies translated label (e.g. t("Draft")) so i18n keys stay string literals. */
  label: ReactNode;
};

export function QueryParamBooleanFilter({
  paramName,
  testID,
  label,
}: QueryParamBooleanFilterProps) {
  const { setParam, clearParam, params } = useQueryParams();

  return (
    <Checkbox
      testID={testID}
      isSelected={params[paramName] === "true"}
      onChange={(isSelected) => {
        if (isSelected) {
          setParam(paramName, "true");
        } else {
          clearParam(paramName);
        }
      }}
    >
      {label}
    </Checkbox>
  );
}
